if (!customElements.get('product-opt')) {
  customElements.define(
    'product-opt',
    class ProductOpt extends window.BAO.CustomElement {
      constructor() {
        super()

        this.colourEls = this.querySelectorAll('[data-el="product-colours.colour"]')

        if (!this.colourEls.length) return

        this.initialiseColourLinks()
      }

      initialiseColourLinks() {
        this.colourEls.forEach(colourEl => {
          if (colourEl.getAttribute('aria-current') === 'true') return

          colourEl.addEventListener('click', this.handleColourClick)
        })
      }

      handleColourClick = event => {
        this.saveSelectedSize()

        const colourEl = event.currentTarget
        const href = colourEl.getAttribute('href')
        const mainProduct = this.closest('main-product')

        if (!href || colourEl.tagName !== 'A' || !mainProduct) return
        if (this.getAttribute('aria-busy') === 'true') {
          event.preventDefault()
          return
        }

        event.preventDefault()
        this.renderProduct(href, mainProduct)
      }

      saveSelectedSize() {
        const selected = document.querySelector(
          '[data-el="product-options.trigger"][aria-pressed="true"]',
        )

        if (!selected || !selected.dataset.value) return

        sessionStorage.setItem('savedSize', selected.dataset.value)
      }

      renderProduct(url, mainProduct) {
        this.setAttribute('aria-busy', 'true')

        fetch(url)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const newMain = html.querySelector('main-product')

            if (!newMain) {
              window.location.href = url
              return
            }

            const title = html.querySelector('title')
            if (title) document.title = title.textContent

            mainProduct.replaceWith(newMain)
            window.history.replaceState({}, '', url)
            window.scrollTo({ top: 0, behavior: 'smooth' })
          })
          .catch(() => {
            window.location.href = url
          })
      }
    },
  )
}
